import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";
import _ from "lodash";
import SearchSelect from "components/common/SearchSelect";
import {
    fetchCountries,
    fetchProvinces,
    fetchCities,
    clearAllLocations
} from "api/menu/master-files/locations/actions";
import SimpleReactValidator from "simple-react-validator";
import getZipCodeRegex from "../../../../../constants/zip-codes";

class TabWorkerContactInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            countriesOptions: this.props.countries.map(value => ({
                value: value.id,
                label: value.fullName
            })),
            provincesOptions: this.props.provinces.map(value => ({
                value: value.id,
                label: value.fullName
            })),
            citiesOptions: this.props.cities.map(value => ({
                value: value.id,
                label: value.name
            })),
        };

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => <div className="text-danger">{message}</div>
        });

        if (this.props.isEditable) {
            this.props.fetchCountries();

            const countryId = this.props.getEmployeeValue("countryId", this.props.tabKey);
            if (countryId) {
                this.props.fetchProvinces(countryId);
            }

            const provinceId = this.props.getEmployeeValue("provinceId", this.props.tabKey);
            if (provinceId) {
                this.props.fetchCities(provinceId);
            }
        }
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.isEditable) {
            const newStates = {};

            if (!_.isEqual(nextProps.countries, this.props.countries)) {
                newStates.countriesOptions = nextProps.countries.map(value => ({
                    value: value.id,
                    label: value.fullName
                }));
            }

            if (!_.isEqual(nextProps.provinces, this.props.provinces)) {
                newStates.provincesOptions = nextProps.provinces.map(value => ({
                    value: value.id,
                    label: value.fullName
                }));
            }

            if (!_.isEqual(nextProps.cities, this.props.cities)) {
                newStates.citiesOptions = nextProps.cities.map(value => ({
                    value: value.id,
                    label: value.name
                }));
            }

            const nextEmployeeData = nextProps.singleEmployee[this.props.tabKey],
                currentEmployeeData = this.props.singleEmployee[this.props.tabKey];
            if (nextEmployeeData && currentEmployeeData) {
                if (nextEmployeeData.countryId !== currentEmployeeData.countryId) {
                    this.setState({
                        provincesOptions: [],
                    });
                    this.props.fetchProvinces(nextEmployeeData.countryId);
                    if (currentEmployeeData.countryId) {
                        this.props.onChange([{
                            name: "province",
                            value: null
                        }, {
                            name: "provinceId",
                            value: null
                        }], this.props.tabKey);
                    }
                }
                if (nextEmployeeData.provinceId !== currentEmployeeData.provinceId) {
                    this.setState({
                        citiesOptions: []
                    });
                    if (nextEmployeeData.provinceId) {
                        this.props.fetchCities(nextEmployeeData.provinceId);
                    }

                    if (currentEmployeeData.provinceId) {
                        this.props.onChange([{
                            name: "city",
                            value: null
                        }, {
                            name: "cityId",
                            value: null
                        }], this.props.tabKey);
                    }
                }
            }
            this.validator.showMessages();
            this.setState(newStates);
        }
    }

    componentWillUnmount () {
        this.props.clearAllLocations();
    }

    render () {
        const { isEditable } = this.props;
        const {
            citiesOptions,
            provincesOptions,
            countriesOptions,
        } = this.state;

        const cityId = this.props.getEmployeeValue("cityId", this.props.tabKey);
        const currentCity = cityId
            ? citiesOptions.find(item => item.value === cityId)
            : null;

        const provinceId = this.props.getEmployeeValue("provinceId", this.props.tabKey);
        const currentProvince = provinceId
            ? provincesOptions.find(item => item.value === provinceId)
            : null;

        const countryId = this.props.getEmployeeValue("countryId", this.props.tabKey);
        const currentCountry = countryId
            ? countriesOptions.find(item => item.value === countryId)
            : null;

        return (
            <div className="container mt-3">

                <div className="row ">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline mb-2">
                            <Form.Label className="mr-2">Address 1</Form.Label>
                            <Form.Control
                                className="w-75"
                                type="text"
                                readOnly={!isEditable}
                                value={this.props.getEmployeeValue("address1", this.props.tabKey)}
                                name="address1"
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                        </Form.Group>
                    </div>
                    <div className="col-4">
                        <Form.Check
                            className="d-flex mt-1"
                            type="checkbox"
                            label="Alternate Address"
                            checked={this.props.getEmployeeValue("isAlternateAddress", this.props.tabKey)}
                            name="isAlternateAddress"
                            onChange={() => {
                                if (isEditable) {
                                    this.props.onChange({
                                        target: {
                                            name: "isAlternateAddress",
                                            value: !this.props.getEmployeeValue("isAlternateAddress", this.props.tabKey)
                                        }
                                    }, this.props.tabKey);
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline mb-2">
                            <Form.Label className="mr-2">Address 2</Form.Label>
                            <Form.Control
                                className="w-75"
                                type="text"
                                readOnly={!isEditable}
                                value={this.props.getEmployeeValue("address2", this.props.tabKey)}
                                name="address2"
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline mb-2">
                            <Form.Label className="mr-2">City</Form.Label>
                            {isEditable ?
                                <div className="w-75">
                                    <SearchSelect
                                        className="custom-react-select g-filter-select-no-padding"
                                        options={citiesOptions}
                                        isClearable={false}
                                        isMulti={false}
                                        isLoading={false}
                                        value={currentCity}
                                        onChange={item => {
                                            this.props.onChange([{
                                                name: "city",
                                                value: item ? item.label : null
                                            }, {
                                                name: "cityId",
                                                value: item ? item.value : null
                                            }], this.props.tabKey);
                                        }}
                                        isDisabled={!isEditable}
                                    />
                                </div>
                                :
                                <Form.Control
                                    className="w-75"
                                    type="text"
                                    defaultValue={this.props.getEmployeeValue("city", this.props.tabKey)}
                                    readOnly={true}
                                />
                            }
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline mb-2">
                            <Form.Label className="mr-2">Province</Form.Label>
                            {isEditable ?
                                <div className="w-75">
                                    <SearchSelect
                                        className="custom-react-select g-filter-select-no-padding"
                                        options={provincesOptions}
                                        isClearable={false}
                                        isMulti={false}
                                        isLoading={false}
                                        value={currentProvince}
                                        onChange={item => {
                                            this.props.onChange([{
                                                name: "province",
                                                value: item ? item.label : null
                                            }, {
                                                name: "provinceId",
                                                value: item ? item.value : null
                                            }], this.props.tabKey);
                                        }}
                                    />
                                </div>
                                :
                                <Form.Control
                                    className="w-75"
                                    type="text"
                                    defaultValue={this.props.getEmployeeValue("province", this.props.tabKey)}
                                    readOnly={true}
                                />
                            }
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline mb-2">
                            <Form.Label className="mr-2">Country</Form.Label>
                            {isEditable ?
                                <div className="w-75">
                                    <SearchSelect
                                        className="custom-react-select g-filter-select-no-padding"
                                        options={countriesOptions}
                                        isClearable={false}
                                        isMulti={false}
                                        isLoading={false}
                                        value={currentCountry}
                                        onChange={item => {
                                            this.props.onChange([{
                                                name: "country",
                                                value: item ? item.label : null
                                            }, {
                                                name: "countryId",
                                                value: item ? item.value : null
                                            }], this.props.tabKey);
                                        }}
                                    />
                                </div>
                                :
                                <Form.Control
                                    className="w-75"
                                    type="text"
                                    defaultValue={this.props.getEmployeeValue("country", this.props.tabKey)}
                                    readOnly={true}
                                />
                            }
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline mb-2">
                            <Form.Label className="mr-2">Postal Code</Form.Label>
                            <Form.Control
                                className="w-75 flex"
                                type="text"
                                readOnly={!isEditable}
                                value={this.props.getEmployeeValue("postalCode", this.props.tabKey)}
                                name="postalCode"
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                        </Form.Group>
                    </div>
                    <div className="col-6">
                        {currentCountry !== null && currentCountry !== undefined && typeof getZipCodeRegex(currentCountry.value) !== "undefined"
                            ? this.validator.message("postalCode", this.props.getEmployeeValue("postalCode", this.props.tabKey), `regex:${getZipCodeRegex(currentCountry.value)}`)
                            : null}
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline mb-2">
                            <Form.Label className="mr-2">Home Phone</Form.Label>
                            <Form.Control
                                className="w-75"
                                type="text"
                                readOnly={!isEditable}
                                value={this.props.getEmployeeValue("homePhone", this.props.tabKey)}
                                name="homePhone"
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline mb-2">
                            <Form.Label className="mr-2">Mobile Phone</Form.Label>
                            <Form.Control
                                className="w-75"
                                type="text"
                                readOnly={!isEditable}
                                value={this.props.getEmployeeValue("mobilePhone", this.props.tabKey)}
                                name="mobilePhone"
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline mb-2">
                            <Form.Label className="mr-2">Office Phone</Form.Label>
                            <Form.Control
                                className="w-75"
                                type="text"
                                readOnly={!isEditable}
                                value={this.props.getEmployeeValue("officePhone", this.props.tabKey) || ""}
                                name="officePhone"
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                        </Form.Group>
                    </div>
                    <div className="col-4">
                        <Form.Group className="d-flex align-items-baseline mb-2">
                            <Form.Label className="mr-2">Ext.</Form.Label>
                            <Form.Control
                                className="w-75"
                                type="text"
                                readOnly={!isEditable}
                                value={this.props.getEmployeeValue("officeExt", this.props.tabKey) || ""}
                                name="officeExt"
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                        </Form.Group>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline mb-2">
                            <Form.Label className="mr-2">Fax</Form.Label>
                            <Form.Control
                                className="w-75"
                                type="text"
                                readOnly={!isEditable}
                                value={this.props.getEmployeeValue("fax", this.props.tabKey) || ""}
                                name="fax"
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                        </Form.Group>
                    </div>
                    <div className="col-4">
                        <div className="d-flex align-items-baseline mt-1">
                            <Form.Check
                                className="d-flex mt-1 mr-3"
                                type="checkbox"
                                label="Call First"
                                checked={this.props.getEmployeeValue("faxCallFirst", this.props.tabKey)}
                                name="faxCallFirst"
                                onChange={() => {
                                    if (isEditable) {
                                        this.props.onChange({
                                            target: {
                                                name: "faxCallFirst",
                                                value: !this.props.getEmployeeValue("faxCallFirst", this.props.tabKey)
                                            }
                                        }, this.props.tabKey);
                                    }
                                }}
                            />
                            <Form.Check
                                className="d-flex mt-1"
                                type="checkbox"
                                label="Do we need a cover sheet"
                                checked={this.props.getEmployeeValue("faxNeedCoverSheet", this.props.tabKey)}
                                readOnly={!isEditable}
                                name="faxNeedCoverSheet"
                                onChange={() => {
                                    if (isEditable) {
                                        this.props.onChange({
                                            target: {
                                                name: "faxNeedCoverSheet",
                                                value: !this.props.getEmployeeValue("faxNeedCoverSheet", this.props.tabKey)
                                            }
                                        }, this.props.tabKey);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Form.Group className="d-flex justify-content-end align-items-baseline mb-2">
                            <Form.Label className="mr-2">Email</Form.Label>
                            <Form.Control
                                className="w-75"
                                type="email"
                                readOnly={!isEditable}
                                value={this.props.getEmployeeValue("email", this.props.tabKey) || ""}
                                name="email"
                                onChange={(ev) => this.props.onChange(ev, this.props.tabKey)}
                            />
                        </Form.Group>
                    </div>
                </div>
            </div>
        );
    }
}

TabWorkerContactInfo.defaultProps = {
    isEditable: false,
};

TabWorkerContactInfo.propTypes = {
    workerId: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
    tabKey: PropTypes.string.isRequired,
    getEmployeeValue: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    isEditable: PropTypes.bool
};

const mapStateToProps = state => ({
    countries: state.locations.countries,
    provinces: state.locations.provinces,
    cities: state.locations.cities,
});

const mapStateToDispatch = dispatch => ({
    fetchCountries: bindActionCreators(fetchCountries, dispatch),
    fetchProvinces: bindActionCreators(fetchProvinces, dispatch),
    fetchCities: bindActionCreators(fetchCities, dispatch),
    clearAllLocations: bindActionCreators(clearAllLocations, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(TabWorkerContactInfo);
